import { createAction } from '@reduxjs/toolkit';
import { createAsyncAction } from 'services/actionConfigs';
import { PREFIX_ACTIONS } from './constants';
import {
  IApiDateRange,
  IApiGetDashboardTimeClockReportParams,
  IApiGetDemoDataParam,
  IApiGetPrintSalaryStaffDetailParams,
  IApiGetPrintSalarySummaryStaffOneDayParams,
  IApiGetPrintSalarySummaryStaffRangeDateParams,
  IApiGetPrintSummaryServiceCategoryParam,
  IApiGetPrintTimeClockRange,
  IApiGetRevenueChart,
  IApiGetSalaryStaffDetailParam,
  IApiGetSummarySalaryStaffParam,
  IApiGetSummarySalonParam,
  IApiGetSummaryTicketParam,
  IApiGetTimeClockReportHistoryParams,
  IApiGetTopRankingServiceParam,
  IApiPrintMultipleCheckItem
} from './types/api';
import { IFilterTypeSalaryStaff, IParams, IPrintSalaryStaffDetailRangeDate, IStaffPayrollPrintData, IViewType } from './types/reportStaff';
import { IParamsReportSalaryStaff, IParamsReportSalaryStaffV2, IParamsReviewReport } from './types/review';
import { ICategoryByProductsData } from 'features/report/services/types/product';

const getDemoData = createAsyncAction<IApiGetDemoDataParam>(PREFIX_ACTIONS + 'getDemoData');

const getPrintSummarySalon = createAsyncAction<IApiGetSummarySalonParam>(PREFIX_ACTIONS + 'getPrintSummarySalon');

const getPrintSummaryPaymentTypes = createAsyncAction<IApiGetSummarySalonParam>(PREFIX_ACTIONS + 'getPrintSummaryPaymentTypes');

const getSummarySalon = createAsyncAction<IApiGetSummarySalonParam>(PREFIX_ACTIONS + 'getSummarySalon');

const getSummaryServiceCategory = createAsyncAction<IApiGetSummarySalonParam>(PREFIX_ACTIONS + 'getSummaryServiceCategory');

const getSummaryTicket = createAsyncAction<IApiGetSummaryTicketParam>(PREFIX_ACTIONS + 'getSummaryTicket');

const getTopRankingService = createAsyncAction<IApiGetTopRankingServiceParam>(PREFIX_ACTIONS + 'getTopRankingService');

const getSummarySalaryStaff = createAsyncAction<IApiGetSummarySalaryStaffParam>(PREFIX_ACTIONS + 'getSummarySalaryStaff');

const getSummarySalarySalon = createAsyncAction<IApiGetSummarySalaryStaffParam>(PREFIX_ACTIONS + 'getSummarySalarySalon');

const getSummaryDashboardSalaryStaff = createAsyncAction<IApiGetSummarySalaryStaffParam>(PREFIX_ACTIONS + 'getSummaryDashboardSalaryStaff');

const setParams = createAction<IParams | undefined>(PREFIX_ACTIONS + 'setParams');

const setCalendarViewType = createAction<IViewType>(PREFIX_ACTIONS + 'setCalendarViewType');

const setFilterTypeSalaryStaff = createAction<IFilterTypeSalaryStaff>(PREFIX_ACTIONS + 'setFilterTypeSalaryStaff');

const getSalaryStaffDetail = createAsyncAction<IApiGetSalaryStaffDetailParam>(PREFIX_ACTIONS + 'getSalaryStaffDetail');

const getPrintSummaryServiceCategory = createAsyncAction<IApiGetPrintSummaryServiceCategoryParam>(PREFIX_ACTIONS + 'getPrintSummaryServiceCategory');

const getDashboardTimeClockReport = createAsyncAction<IApiGetDashboardTimeClockReportParams>(PREFIX_ACTIONS + 'getDashboardTimeClockReport');

const getTimeClockReportHistory = createAsyncAction<IApiGetTimeClockReportHistoryParams>(PREFIX_ACTIONS + 'getTimeClockReportHistory');

const getPrintSalaryStaffDetailOneDay = createAsyncAction<IApiGetPrintSalaryStaffDetailParams>(PREFIX_ACTIONS + 'getPrintSalaryStaffDetailOneDay');

const getPrintSalaryStaffDetailRangeDate = createAsyncAction<IApiGetPrintSalaryStaffDetailParams>(PREFIX_ACTIONS + 'getPrintSalaryStaffDetailRangeDate');

const getPrintSalarySummaryStaffOneDay = createAsyncAction<IApiGetPrintSalarySummaryStaffOneDayParams>(PREFIX_ACTIONS + 'getPrintSalarySummaryStaffOneDay');

const getPrintSalarySummaryStaffRangeDate = createAsyncAction<IApiGetPrintSalarySummaryStaffRangeDateParams>(PREFIX_ACTIONS + 'getPrintSalarySummaryStaffRangeDate');

const getReviewReport = createAsyncAction<IParamsReviewReport>(PREFIX_ACTIONS + 'getReviewReport');

const getReviewReportSummary = createAsyncAction<IParamsReviewReport>(PREFIX_ACTIONS + 'getReviewReportSummary');

const setReviewReportParams = createAction<IParamsReviewReport>(PREFIX_ACTIONS + 'setReviewReportParams');

const initReviewReportParams = createAction(PREFIX_ACTIONS + 'initReviewReportParams');

const getCheckNum = createAsyncAction(PREFIX_ACTIONS + 'getCheckNum');
const getPrintCheckAll = createAsyncAction<{ startDate: string, endDate: string }>(PREFIX_ACTIONS + 'getPrintCheckAll');
const getPrintCheckAllV2 = createAsyncAction<{ startDate: string, endDate: string, staffIds?: string[] }>(PREFIX_ACTIONS + 'getPrintCheckAllV2');
const getPrintTimeClockRange = createAsyncAction<IApiGetPrintTimeClockRange>(PREFIX_ACTIONS + 'getPrintTimeClockRange');

const getSummaryAppointmentChart = createAsyncAction<IApiGetRevenueChart>(PREFIX_ACTIONS + 'getSummaryAppointmentChart');
const getSummarySaleChart = createAsyncAction<IApiGetRevenueChart>(PREFIX_ACTIONS + 'getSummarySaleChart');
const getSummaryCategoryChart = createAsyncAction<IApiDateRange>(PREFIX_ACTIONS + 'getSummaryCategoryChart');
const getSummaryPaymentTypeChart = createAsyncAction<IApiDateRange>(PREFIX_ACTIONS + 'getSummaryPaymentTypeChart');

const getReportSalaryStaff = createAsyncAction<IParamsReportSalaryStaff, IStaffPayrollPrintData[]>(PREFIX_ACTIONS + 'getReportSalaryStaff');
const getReportSalaryStaffV2 = createAsyncAction<IParamsReportSalaryStaffV2, IStaffPayrollPrintData[]>(PREFIX_ACTIONS + 'getReportSalaryStaffV2');

const productReportInitial = createAction<IApiGetSummarySalonParam>(PREFIX_ACTIONS + 'productReportInitial');
const getCashDepositReport = createAsyncAction<IApiGetSummarySalonParam>(PREFIX_ACTIONS + 'getCashDepositReport');
const deleteCashDeposit = createAction<string>(PREFIX_ACTIONS + 'deleteCashDeposit');

const getProductReport = createAsyncAction<IApiGetSummarySalonParam, ICategoryByProductsData[]>(PREFIX_ACTIONS + 'getProductReport');
const printMultipleCheck = createAction<IApiPrintMultipleCheckItem[]>(PREFIX_ACTIONS + 'printMultipleCheck');

const setPayrollSelectedRowKeys = createAction<React.Key[]>(PREFIX_ACTIONS + 'setPayrollSelectedRowKeys');

const getReportSalaryStaffYearly = createAsyncAction<{ year: number, staffIds?: string[] }>(PREFIX_ACTIONS + 'getReportSalaryStaffYearly');

const getHomeReportDiscount = createAsyncAction(PREFIX_ACTIONS + 'getHomeReportDiscount');

const reportActions = {
  getDemoData,
  getSummarySalon,
  getPrintSummarySalon,
  getSummaryServiceCategory,
  getSummaryTicket,
  getTopRankingService,
  getSummarySalaryStaff,
  getSummarySalarySalon,
  getSummaryDashboardSalaryStaff,
  setParams,
  setCalendarViewType,
  setFilterTypeSalaryStaff,
  getSalaryStaffDetail,
  getPrintSummaryServiceCategory,
  getDashboardTimeClockReport,
  getTimeClockReportHistory,
  getPrintSalaryStaffDetailOneDay,
  getPrintSalaryStaffDetailRangeDate,
  getPrintSalarySummaryStaffOneDay,
  getPrintSalarySummaryStaffRangeDate,
  getReviewReport,
  getReviewReportSummary,
  setReviewReportParams,
  initReviewReportParams,
  getPrintSummaryPaymentTypes,
  getPrintCheckAll,
  getPrintCheckAllV2,
  getCheckNum,
  getPrintTimeClockRange,
  getSummaryAppointmentChart,
  getSummarySaleChart,
  getSummaryCategoryChart,
  getSummaryPaymentTypeChart,
  getReportSalaryStaff,
  getReportSalaryStaffV2,
  productReportInitial,
  getCashDepositReport,
  deleteCashDeposit,
  getProductReport,
  printMultipleCheck,
  setPayrollSelectedRowKeys,
  getReportSalaryStaffYearly,
  getHomeReportDiscount,
};

export default reportActions;

